import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../Layout.jsx';

// Import pages
import Dashboard from '../pages/Dashboard.jsx';
import Interview from '../pages/Interview.jsx';
import AIAssistant from '../pages/AIAssistant.jsx';
import Review from '../pages/Review.jsx';
import Forms from '../pages/Forms.jsx';
import Documents from '../pages/Documents.jsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/Dashboard" replace />} />
        <Route
          path="/Dashboard"
          element={
            <Layout currentPageName="Dashboard">
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/Interview"
          element={
            <Layout currentPageName="Interview">
              <Interview />
            </Layout>
          }
        />
        <Route
          path="/AIAssistant"
          element={
            <Layout currentPageName="AI Assistant">
              <AIAssistant />
            </Layout>
          }
        />
        <Route
          path="/Review"
          element={
            <Layout currentPageName="Review">
              <Review />
            </Layout>
          }
        />
        <Route
          path="/Forms"
          element={
            <Layout currentPageName="Forms">
              <Forms />
            </Layout>
          }
        />
        <Route
          path="/Documents"
          element={
            <Layout currentPageName="Documents">
              <Documents />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
